import { useContext } from 'react';
import Footer from '../components/Footer';
import { Container } from "react-bootstrap";
import Header2 from "../components/Header2";
import { ProfileContext } from '../context/ProfileContext';

const PrivacyPolicy = () => {
  const { CMS, isLoading } = useContext(ProfileContext)

  return (
    <div>
      <section className="comm_page_banner privacy_page_banner" style={{ backgroundImage: `url(${require('../Assets/Images/comm_page_bg.png')})` }}>
        <Container>
          <Header2 />
          <h3 className="comm_page_heading">Privacy Policy</h3>
        </Container>
      </section>

      <div className="comm_page_layout">
        <Container>
          <div className="text_editor_conent_outer">
            {isLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: CMS.privacyPolicy }} />
            )}
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;